import { FC } from 'react';
import { SubmenuType } from '@/config/navigationPages';

import NestedSubmenuItem from '../NestedSubmenuItem';

import styles from './NestedSubmenu.module.sass';

interface NestedSubmenuProps {
  items: SubmenuType[];
  locationPathname: string;
  level?: number;
}

const NestedSubmenu: FC<NestedSubmenuProps> = ({
  items,
  locationPathname,
  level = 2,
}) => {
  return (
    <div className={styles.nestedSubmenu}>
      {items.map((item) => (
        <NestedSubmenuItem
          key={item.path}
          item={item}
          locationPathname={locationPathname}
          level={level}
        />
      ))}
    </div>
  );
};

export default NestedSubmenu;
